export const SET_USERS_LIST = "SET_USERS_LIST";
export const SET_CUSTOMER_CONTEXT = "SET_CUSTOMER_CONTEXT";
export const SET_CUSTOMER_INFO_CHANGE_HISTORY =
  "SET_CUSTOMER_INFO_CHANGE_HISTORY";
export const UPDATE_CUSTOMER_INFO_CHANGE_HISTORY =
  "UPDATE_CUSTOMER_INFO_CHANGE_HISTORY";
export const MSG = "MSG";
